export const mercuryRegex = /<([^>]+)>;\s+rel=(?:mercure|"[^"]*mercure[^"]*")/;

export const blockMultipleSpaces = (value: string): string =>
  value.replace(/\s\s+/g, ' ');
